export const getEnvValue = (envVal, defaultValue = null) => ((envVal !== '' && envVal !== 'null' && envVal !== undefined && envVal !== null) ? envVal : defaultValue);
